import clsx from 'clsx';
import { Button } from 'components/UI/Button/Button';
import React from 'react';
import { formatPurchaseOfferPrice, PurchaseOffer } from 'types/Purchase';
import classes from './PurchaseOfferCard.module.scss';

interface PurchaseOfferCardProps {
    offer: PurchaseOffer;
    selected: boolean;
    onToggle: () => void;
}

export const PurchaseOfferCard: React.FC<PurchaseOfferCardProps> = ({
    offer,
    selected,
    onToggle
}) => {
    const [isOpen, setIsOpen] = React.useState(false);

    return (
        <div className={clsx(classes.root, { [classes.selected]: selected })}>
            <div className={classes.header}>
                <div className={classes.headerContent}>
                    <p className={classes.title} onClick={onToggle}>
                        {offer.name}
                    </p>

                    <p className={classes.price}>{formatPurchaseOfferPrice(offer)}</p>
                </div>

                <Button
                    size="small"
                    variant={selected ? 'black' : 'outlined'}
                    className={classes.button}
                    onClick={onToggle}
                >
                    {selected ? 'Selected' : 'Select'}
                </Button>
            </div>

            {isOpen && (
                <div className={classes.details}>
                    {offer.details.map(detail => (
                        <p key={detail}>{detail}</p>
                    ))}
                </div>
            )}

            <div>
                <button type="button" className={classes.toggle} onClick={() => setIsOpen(!isOpen)}>
                    {isOpen ? 'Hide info' : 'More info'}
                </button>
            </div>
        </div>
    );
};
